import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectAssignmentComponent } from './project-assignment.component';

const routes: Routes = [
  {
    path: '',
    component: ProjectAssignmentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectAssignmentRoutingModule { }
